module.exports = __webpack_public_path__ + "static/media/key-icon-active.f09ce43d.svg";